import Splide from '@splidejs/splide';

const PresentationSlider = () => {
    const selector = 'section.presentation-slider .splide';
    const init = () => {
        const splide = new Splide(selector, {
            type   : 'loop',
            perPage: 2,
            perMove: 1,
            gap: '25px',
            pagination: false,
        }).mount();

        splide.on('active', function (SlideComponent) {
            const newIteration = SlideComponent.index + 1;
            $(selector + ' .js--loop-iteration').html('0' + newIteration)
        });

        splide.on('click', function () {
            splide.go('+1');
        });
    };

    if ($(selector).length > 0) {
        init();
    }

    /* return ({
        init,
    }); */
}
export default PresentationSlider;
